import { z } from "zod";

export const accrualDocumentBodySchema = z.object({
    financialDocumentIds: z.array(z.number().int()).min(1).max(100),
});

export type AccrualDocumentBody = z.infer<typeof accrualDocumentBodySchema>;
